import { v4 } from 'uuid';

import { createFilterReducer } from '../filter';
import {
  dashboardUsersFilterActions,
  dashboardUsersFilterActionsPrefix,
} from '../../constants/filter';
import { dateColumns } from '../../constants/event';
import { fromFilter } from '../../converters/filterConverter';
import { unitsTypes } from '../../constants/dashboards';

const getColumnsFromTemplate = (isAggregate, query) =>
  isAggregate
    ? query.groupBy.map((column) => ({
        id: v4(),
        value: column,
      }))
    : query.columns.map((column) => ({
        id: v4(),
        value: column,
      }));

const filterReducer = createFilterReducer(dashboardUsersFilterActionsPrefix);

const initialState = {
  event: null,
  columns: [],
  aggregate: true,
  filter: filterReducer(undefined, {}),
  idUsingTemplate: undefined,
  sql: '',
  error: '',
};

const usersCompose = (state = initialState, action) => {
  switch (action.type) {
    case 'DASHBOARD_CHANGE_USERS_EVENT':
      return {
        ...state,
        event: action.event,
        columns: [],
        filter: filterReducer(undefined, {}),
      };

    case 'DASHBOARD_SET_USERS_EVENT_COLUMNS_VALUE':
      return {
        ...state,
        columns: state.columns.map((c) => (c.id === action.id ? { ...c, value: action.value } : c)),
      };

    case 'DASHBOARD_ADD_USERS_EVENT_COLUMN':
      return {
        ...state,
        columns: [...state.columns, { id: v4() }],
      };

    case 'DASHBOARD_DELETE_USERS_EVENT_COLUMN':
      return {
        ...state,
        columns: state.columns.filter((c) => c.id !== action.id),
      };

    case 'DASHBOARD_AGGREGATE_USERS':
      return {
        ...state,
        aggregate: !state.aggregate,
      };

    case dashboardUsersFilterActions.ADD_FILTER_CLAUSE:
    case dashboardUsersFilterActions.COPY_FILTER:
    case dashboardUsersFilterActions.REMOVE_FILTER:
    case dashboardUsersFilterActions.REMOVE_FILTER_CLAUSE:
    case dashboardUsersFilterActions.SET_FILTER_CLAUSE_FIELD:
    case dashboardUsersFilterActions.SET_FILTER_CLAUSE_VALUE:
    case dashboardUsersFilterActions.SET_CLAUSES_CONCAT_OPERATOR:
    case dashboardUsersFilterActions.SET_FILTER_CLAUSE_OPERATOR:
    case dashboardUsersFilterActions.SET_FILTER_VISIBILITY:
      return {
        ...state,
        filter: filterReducer(state.filter, action),
      };

    case 'DASHBOARD_EXPOSE_USERS_QUERY_SUCCESS':
      return {
        ...state,
        error: '',
        sql: action.sql,
      };

    case 'DASHBOARD_SET_USERS_EXPOSURE_ERROR':
      return {
        ...state,
        sql: '',
        error: action.error,
      };

    case `DASHBOARD_SET_TEMPLATE_${unitsTypes.USERS_TYPE}`: {
      const { query } = action.template.queries[0];
      const isAggregate = query.groupBy !== undefined;
      return {
        ...state,
        event: query.eventName,
        columns: getColumnsFromTemplate(isAggregate, query).filter(
          (column) =>
            column.value !== 'event.user_id' && !Object.values(dateColumns).includes(column.value)
        ),
        aggregate: isAggregate,
        filter: fromFilter(query.filter, (field) =>
          action.template.filterExtractor(query.eventName, field)
        ),
        idUsingTemplate: action.template.id,
      };
    }

    default:
      return state;
  }
};

export default usersCompose;

export const getEvent = (state) => state.event;

export const getColumns = (state) => state.columns;

export const isAggregateEnabled = (state) => state.aggregate;

export const getUserFilter = (state) => state.filter;

export const getIdUsingTemplate = (state) => state.idUsingTemplate;

export const getUsersSQL = (state) => state.sql;

export const getError = (state) => state.error;
